import React, { useState } from 'react';

import StrViewNGL from './StrViewNGL';
import StructureControls from './StructureControls';

function StructureViewer(props) {

    const { pdbId, domainId, domainInfo } = props

    const [showSpin, setShowSpin] = useState(false);
    const [showSurface, setShowSurface] = useState(false);

    const onChangeStructuralFeature = (feature, state) => {
        if (feature === 'spin') {
            setShowSpin(state);
        }
        else if (feature === 'surface') {
            setShowSurface(state);
        }
    };

    return (
        <div>
            {/* {<StructureControls onChangeFeature={onChangeStructuralFeature} />} */}
            <StrViewNGL pdbId={pdbId}
                domainId={domainId}
                domainInfo={domainInfo}
                selectedResidues={props.selectedResidues}
                onLoadStructure={props.onLoadStructure}
                spin={showSpin}
                funsiteResidueSets={props.funsiteResidueSets}
                surface={showSurface}></StrViewNGL>
        </div>
    );
}

export default StructureViewer;